import script from "./AlertView.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertView.vue?vue&type=script&setup=true&lang=js"

import "./AlertView.vue?vue&type=style&index=0&id=8d0f8b22&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LEGION\\Desktop\\SONNAR\\proiBueno\\virgen\\reppsoc-ppqy9-portaltuturesweb\\reppsoc-ppqy9-portaltuturesweb\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d0f8b22"]])

export default __exports__